import * as signalR from "@microsoft/signalr";
import Cookies from "js-cookie";
import {LogLevel} from "@microsoft/signalr";
import {cacheTokensWithExpiration} from "./Utils";
import {refreshAccessToken} from "./Request";

// This keeps a single, global instance of the SignalR client
export class Websocket {
    static Client;

    static getAccessToken = async () => {
        let token = Cookies.get("accessToken");
        if (!token) {
            const refreshToken = localStorage.getItem("refreshToken");
            if (refreshToken) {
                const response = await refreshAccessToken(refreshToken);
                if (response?.status === 200) {
                    cacheTokensWithExpiration(response);
                    token = Cookies.get("accessToken");
                }
            }
        }
        return token;
    }

    static setupClient() {
        if (this.Client && this.Client?.state === signalR.HubConnectionState.Connected) {
            return false; // Already created
        }
        const url = process.env.REACT_APP_API_URL + "/websocket";
        this.Client = new signalR.HubConnectionBuilder()
            .withHubProtocol(new signalR.JsonHubProtocol())
            .withUrl(url, {
                transport: signalR.HttpTransportType.WebSockets | signalR.HttpTransportType.ServerSentEvents | signalR.HttpTransportType.LongPolling,
                accessTokenFactory: this.getAccessToken,
                UseReconnects: true,
                logger: LogLevel.Error,
            })
            .withAutomaticReconnect()
            .build();
        return true; // Needed to be created
    }
}